import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { Button } from '@mui/material';

interface Props {
    label: string;
    onClick?: () => void;
}

export default function AddButtonTextVariant({ label, onClick }: Props) {
    return (
        <Button
            variant="text"
            onClick={onClick}
            sx={{ textTransform: 'initial' }}
            startIcon={<AddOutlinedIcon></AddOutlinedIcon>}
        >
            {label}
        </Button>
    );
}
